export class SelfTriageCounselingRequest{
    public selfTriageCounselingName: string;
    public counseling: string;
}